
document.addEventListener('DOMContentLoaded', () => {
  const cartItems = window.cartItemsData || [];
  const isB2B = window.customerIsB2B || false;
  const customerId = window.customerId || '';

  window.reftick = 0;

  if (!cartItems.length) return;

  const EPS = 0.01;


  window.updateAllPriceDisplay = function () {



    async function fetchWithModernTimeout(url) {
      try {
        // Automatically aborts the request after 5000 milliseconds (5 seconds)
        const response = await fetch(url, {
          signal: AbortSignal.timeout(25000)
        });

        return response;
      } catch (error) {

          console.error('A different network error occurred:', error);
        return { "status": 500 }
      }
    }

  let totalall = 0;
    cartItems.forEach((item) => {
    const lineId = item.key;
    const sku = item.sku?.split('-')[0];
    const basePrice = parseFloat(item.basePrice || 0);   // per lb
    const discountPct = parseFloat(item.discountPercentage || 0);
    const productType = item.productType || '';
    const productId = item.productId || '';







    const totlaPrice=document.querySelector(".totals__total-value");
      const input = document.querySelector(`[data-id="${lineId}"]`);

/*

      input.addEventListener('change', () => {

        if (window.refTick) {
          clearTimeout(window.refTick);
        }
        window.refTick = window.setTimeout(() => {
          window.updateAllPriceDisplay();
        }, 1200)
      });
 */



    const wrapper = document.querySelector(`[data-wrapper-id="${lineId}"]`);//input?.closest('.cart-item__price-wrapper');
    if (!input || !wrapper) return;

    const priceDisplayElm = document.getElementById(`price-display-${lineId}`);
    const oldPrice=priceDisplayElm.innerText;
    const unitPriceElm = document.getElementById(`final-price-display-${lineId}`);
    if (!priceDisplayElm || !unitPriceElm) return;

    // The strike-through (base/original) container and span
    const basePriceElm = document.getElementById(`old-price-display-${lineId}`);
    const basePriceWrap = basePriceElm?.closest('.base-price-wrap');

    const updatePriceDisplay = async () => {
      const qty = parseInt(input.value) || 1;
      const needsApi = (productType === 'MTO' || productType === 'Stock') && !isB2B;

      if (!needsApi) {
        // B2B or non-dynamic: just reflect what Shopify has

        var uselinePrice=parseFloat(item.linePrice || 0);
        var userunitPrice=parseFloat(item.unitPrice || 0);

        if(item.price_break.length>1){
          for(let i=0;i<item.price_break.length;i++){
            let testitem=item.price_break[i];
            if(qty>=testitem.minimum_quantity){
              userunitPrice=testitem.price;
            }
          }
        }

        const unit = userunitPrice;
        const total = userunitPrice * qty;
        totalall += total;
        // Hide the base/original block (no discount UX in this path)
        if (basePriceWrap) basePriceWrap.style.display = 'none';

        priceDisplayElm.innerHTML = `<strong>${total.toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
        })}</strong>`;
        unitPriceElm.innerHTML = `${unit.toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
        })} per lb`;
        return;
      }

      let unitPrice, totalPrice;
      try {
        let url = 'https://app-ppgpowdercoatings-prd-prd-01.azurewebsites.net'
          + `/api/ShopifyOrderPreCalculation/price-discount?productId=${productId}&sku=${sku}&count=${qty}`;
        if (customerId) url += `&customerId=${customerId}`;
        if (discountPct) url += `&percentOff=${discountPct}`;

        const response = await fetchWithModernTimeout(url);

        if (response.status !== 200) throw new Error('API request failed');

        const data = await response.json();

        totalPrice = parseFloat(data.totalAmount || 0);

        unitPrice = parseFloat(data.pricePerPound || 0);
      } catch (e) {
        // Fallback to base pricing math if API fails
        unitPrice = basePrice;
        totalPrice = basePrice * qty;
      }
      totalall += totalPrice;
      // Totals
      /*
      priceDisplayElm.innerHTML = `<strong>${totalPrice.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
      })}</strong>`;
      */



      const totalPriceTmpl =`
        <dl class="cart-item__discounted-prices">
          <dt class="visually-hidden">
            Regular price
          </dt>
          <dd>
          <s class="cart-item__old-price price price--end" id="price-display-${lineId}">
          ${oldPrice}
          </s>
          </dd>
          <dt class="visually-hidden">
            Sale price
          </dt>
          <dd class="price price--end">
          ${totalPrice.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
          })}
          </dd>
      </dl>`

      if (unitPrice != basePrice) {
        wrapper.innerHTML = totalPriceTmpl;
      }



      // Show or hide the BASE TOTAL (strike-through) only if base > unit (true discount)
      if (basePriceWrap) {
        if (basePrice > unitPrice + EPS) {
          basePriceWrap.style.display = 'block';
          // Show the original total in the strike-through (base per-lb * qty)
          basePriceElm.textContent = `${(basePrice * qty).toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
          })}`;
        } else {
          basePriceWrap.style.display = 'none';
        }
      }

      // Per-lb line: only strike-through when base > unit
      const showPerLbStrike = basePrice > unitPrice + EPS;
      unitPriceElm.innerHTML = `

          ${showPerLbStrike ? `<s style="color:#888;">${basePrice.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
          })} per lb</s> → ` : ''}
          $${unitPrice.toFixed(2).toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
          })} per lb

      `;



      totlaPrice.innerText = totalall.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
      });



    };




      updatePriceDisplay();
    });

}




  // Listen for item line changes (additions, updates, or removals)

  window.updateAllPriceDisplay();

  if (window.publish !== undefined && window.subscribe !== undefined && PUB_SUB_EVENTS?.cartUpdate !== undefined) {
    window.subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => {
      console.log("cartupdate")
      console.log(e)
      window.updateAllPriceDisplay();

      window.limitPanelQuantity();
    });

  }




  window.updateAllPriceDisplay();



});
